export default __webpack_public_path__ + "static/media/trib_m_bg.4b62c954.png";